import packageJson from "../../package.json";
import get from 'lodash/get'

export default get(packageJson, 'version', '0.0.0')
